<app-reg-person-payment-form [money]="form"></app-reg-person-payment-form>
<p-toolbar>
  <div class="p-toolbar-group-left">
    <button pButton type="button" label="Сохранить" class="p-button-success" (click)="onSubmit()"></button>
  </div>
  <div class="p-toolbar-group-right">
    <button pButton type="button" label="Отмена" class="p-button-secondary" (click)="onCancel()"></button>
  </div>
</p-toolbar>
